module.exports = __webpack_public_path__ + "static/img/node_js.d42672d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/node_js.png
// module id = NKZh
// module chunks = 0